import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box } from '@mui/material';
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
const columns = [
    { field: 'id', headerName: 'SrNo', flex: 1 },
    { field: 'ApplicationNo', headerName: 'ID', flex: 1 },
    { field: 'ApplyingDate', headerName: 'Apply Date', flex: 1 },
    { field: 'LeavePurpose', headerName: 'Reason', flex: 1 },
    { field: 'leavetype', headerName: 'Leave Type', flex: 1 },
    { field: 'ApplicationStatus', headerName: 'Status', flex: 1 },
    { field: 'Days', headerName: 'Days', type: 'number', flex: 1 },
    { field: 'EmergencyLeave', headerName: 'EL', type: 'number', flex: 1 },
    { field: 'PlannedLeave', headerName: 'PL', type: 'number', flex: 1 },
    { field: 'Balance', headerName: 'Balance', type: 'number', flex: 1 },
];

const rows = [
    { id: 1, ApplicationNo: '', ApplyingDate: '', LeavePurpose: '', leavetype: '', ApplicationStatus: '', Days: '', EmergencyLeave: '', PlannedLeave: '', Balance: '' },
];

const TranssitionHistory = () => {
    const [data, setData] = useState(rows);
    const userEmail = localStorage.getItem('UserEmail') || '';
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
    useEffect(() => {
        const fetchData = async () => {
            // const response = await fetch('http://127.0.0.1:5000/GetLeaveTransaction', {

            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/GetLeaveTransaction`, {    
                method: 'POST',
                headers: { 'Content-Type': 'application/json' ,'Authorization': `Bearer ${accessToken}`},
                body: JSON.stringify({ userEmail: userEmail }), // Replace with actual user email
            });
            const jsonData = await response.json();
            const formattedData = jsonData.map((item, index) => ({
                ...item,
                id: index + 1,
            }));
            setData(formattedData);
        };

        fetchData();
    }, [userEmail]);

    return (
        <Box m="20px">
            <Header title="LEAVE  TRANSACTIONS  HISTORY " />
            <Box m="40px 0 0 0" height="75vh" sx={{
                "& .MuiDataGrid-root": {
                    border: "none",
                },
                "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                },
                "& .name-column--cell": {
                    color: colors.greenAccent[300],
                },
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: colors.blueAccent[700],
                    borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                    backgroundColor: colors.primary[400],
                },
                "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: colors.blueAccent[700],
                },
                "& .MuiCheckbox-root": {
                    color: `${colors.greenAccent[200]} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[100]} !important`,
                },
            }}>
                <DataGrid
                    columns={columns}
                    rows={data}
                    pagination
                    pageSize={10}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    components={{ Toolbar: GridToolbar }}
                    autoHeight

                />
            </Box>
        </Box>
    );
};

export default TranssitionHistory;
